"use strict";
/// <reference path="irep.js"/>


IREP.badgewall = (function () {
    var sliderOut = 0;
    var options;
    var currBadge, lblEarned, lblNotEarned;
    var badgeParams;

    var init = function () {
        $("body").addClass("badgewallBackground");
        currBadge = $("#badgeCode").val();
        lblEarned = $("#earnedText").val();
        lblNotEarned = $("#unearnedText").val();
        loadFirstBadge(currBadge);
        setSliderBackground();
        $("#sliderButton").click(animateSlider);
        $(".badge").click(function () {
            var badge = $(this);
            if (!badge.hasClass("archived")) {
                clickBadge(badge.data('badgecode'));
            }
        });
        $(".changeButton").click(function () {
            var that = $(this).data('view');
            changeview(that);
        });

        $('#badgeContainer').isotope({
            filter: '.active:not(.onlyshowifearned)',
            itemSelector: '.badge',
            layoutMode: 'fitRows'
        });

    };

    var showLoader = function (show) {
        if (show === 1) {
            $('#imgLoader').fadeTo(0, 1);
            $('#badgeInfo').fadeTo(200, 0);
            $('#graph').fadeTo(200, 0);
        } else {
            $('#imgLoader').fadeTo(800, 0);
            $('#badgeInfo').fadeTo(500, 1);
            $('#graph').fadeTo(500, 1);
        }
    };

    var getBadgeDetails = function (params) {
        IREP.callApi("/badgewall/participantbadge", "GET", params).done(function (data) {
            if (data !== null) {
                displayBadgeInfo(data, params.code);
            }
        }).fail(function (data) { });
    };

    var displayBadgeInfo = function (data, badgeCode) {
        var participantBadge = data.participantBadge;
        var badge = participantBadge.badge;
        //if (IREP.options.user.geoCode === "ASMO" && badge.isAvailable === false && moment(badge.availableDate).isBefore('2013-12-27')) {
        //    $("#shadowContainer").hide();
        //} else {
        //    $("#shadowContainer").show();
        //} Leaving this here in case we want to use it in the future
        $("#divTitle").html(badge.title);
        $("#divSubTitle").html(badge.subTitle);
        $("#divDesc").html(badge.description);
        if (participantBadge.earned === true) {
            var dateEarned = IREP.options.user.geoCode === "ASMO" ? moment(participantBadge.earnedDate).format('MM/DD/YYYY') : moment(participantBadge.earnedDate).format('DD/MM/YYYY');
            $("#divEarned").html("<span style='font-weight:bold; color:#222222'>" + lblEarned + "&nbsp;</span>" + dateEarned);
            $("#imgCover").hide();
        } else {
            $("#divEarned").html("<span style='font-weight:bold; color:#222222'>" + lblEarned + "&nbsp;</span>" + lblNotEarned);
            $("#imgCover").show();
        }

        // $("#imgBadge").attr('src', '../images/BadgeWall/' + badgeCode + '_Lrg.png');

        if (badge.isAvailable === true) {
            $("#divRetired").hide();
        } else {
            $("#divRetired div.date").text(moment(badge.availableDate).format("YYYY"));
            $("#divRetired").show();
            $("#imgCover").hide();
        }

        if (badge.ownedBy > 30) {
            $('#barText').addClass('left').removeClass('right');
        } else {
            $('#barText').addClass('right').removeClass('left');
        }

        var barWidth = (432 / 100) * badge.ownedBy;
        $('#bar').width(0);
        $('#bar').delay(200).animate({ width: barWidth + 'px' }, 1200);
        $("#barText").text(parseFloat(Math.round(badge.ownedBy * 100) / 100).toFixed(2) + "%");


        showLoader(0);
    };

    var clickBadge = function (badgeCode) {
        if (currBadge !== badgeCode) {
            if (sliderOut === 0) {
                animateSlider();
            }
            $('#badgeInfo').hide();
            $('#graph').hide();

            showLoader(1);

            // Load the Slider content for this badge
            // Load the image first to give it some time to load...
            $("#imgBadge").attr('src', IREP.options.appUrl + 'content/images/BadgeWall/' + badgeCode + '_Lrg.png');
            getBadgeDetails(buildBadgeParams(badgeCode));

            currBadge = badgeCode;
        } else {
            animateSlider();
        }
    };

    var changeview = function (view) {
        $('#badgeContainer').isotope({
            animationOptions: {
                duration: 750,
                easing: 'linear',
                queue: false
            }
        });

        if (sliderOut === 1) {
            animateSlider();
        }

        if (view === 'ALL') {
            swapButtonBackground($("#viewAll"));

            $('#badgeContainer').isotope({
                filter: '.active:not(.onlyshowifearned)',
                itemSelector: '.badge',
                layoutMode: 'fitRows'
            });
            $('#desc_current').show();
            $('#desc_archived, #desc_earned, #desc_unearned').hide();
        } else if (view === 'EARNED') {
            swapButtonBackground($("#viewEarned"));

            $('#badgeContainer').isotope({
                filter: '.earned',
                itemSelector: '.badge',
                layoutMode: 'fitRows'
            });
            $('#desc_earned').show();
            $('#desc_current, #desc_unearned, #desc_archived').hide();

        } else if (view === 'UNEARNED') {
            swapButtonBackground($("#viewUnearned"));

            $('#badgeContainer').isotope({
                filter: '.unearned',
                itemSelector: '.badge',
                layoutMode: 'fitRows'
            });
            $('#desc_unearned').show();
            $('#desc_current, #desc_earned, #desc_archived').hide();

            $('#badgeContainer').isotope({
                filter: '.unearned:not(.onlyshowifearned)',
                itemSelector: '.badge',
                layoutMode: 'fitRows'
            });

        } else if (view === 'ARCHIVED') {
            swapButtonBackground($("#viewArchived"));
            $(".archived").show();

            $('#badgeContainer').isotope({
                filter: '.archived',
                itemSelector: '.badge',
                layoutMode: 'fitRows'
            });
            $('#desc_archived').show();
            $('#desc_current, #desc_earned, #desc_unearned').hide();
        }

        toggleSliderVisibility(view);
    };

    var toggleSliderVisibility = function (view) {
        if (view == "ARCHIVED") {
            $("#sliderFrame").fadeOut(500);
        } else {
            $("#sliderFrame").fadeIn(500);
        }

    };

    var swapButtonBackground = function (button) {
        $(".viewButton").each(function () {
            $(this).removeClass("on");
        });
        button.addClass("on");
    };

    var loadFirstBadge = function (firstBadge) {
        //// Load the first badge as default content
        getBadgeDetails(buildBadgeParams(firstBadge));
        $("#imgBadge").attr('src', IREP.options.appUrl + '/content/images/BadgeWall/' + firstBadge + '_Lrg.png');
    };

    var buildBadgeParams = function (badgeCode) {
        return { code: badgeCode, participantUID: IREP.options.user.currentUID, siteCollection: IREP.options.user.geoCode, cultureCode: IREP.options.user.cultureCode };
    };

    ////if ($.browser.msie) {
    ////    //Hack for IE 7 and early IE8:
    ////    $("#SliderFrame").css("z-index", "150");
    ////}

    var animateSlider = function () {

        if (sliderOut === 1) {
            $('#sliderFrame').animate({ width: "72px" }, 500);
            $('#expandImg').show();
            sliderOut = 0;
        } else {
            $('#sliderFrame').animate({ width: "600px" }, 500);
            $('#expandImg').hide();
            sliderOut = 1;
        }

        $(".badge").trigger("badge.drawer.open");

        return false;
    };

    var setSliderBackground = function () {
        if (IREP.options.isRTL) {
            $("#slider").addClass("sliderBackground-rtl");
            $("#expandImg").prop("src", IREP.options.appUrl + "Content/images/BadgeWall/Expand-right.png");
        } else {
            $("#slider").addClass("sliderBackground-ltr");
            $("#expandImg").prop("src", IREP.options.appUrl + "Content/images/BadgeWall/Expand-left.png");
        }
    };

    // Running low in page to make sure top has loaded...
    if ($('html').prop('dir') === 'rtl') {
        $('#badgeContainer').isotope({
            transformsEnabled: false,
            layoutMode: 'fitRows',
            animationOptions: {
                duration: 750,
                easing: 'linear',
                queue: false
            }
        });
    } else {
        $('#badgeContainer').isotope({
            transformsEnabled: true,
            layoutMode: 'fitRows',
            animationOptions: {
                duration: 750,
                easing: 'linear',
                queue: false
            }
        });
    }

    $("#badgewall").removeAttr("style");

    
    return {
        init: init
    };
})();
